import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { Icon } from 'antd';
import 'eyedropper-polyfill';

import { hexToRgbArr } from '../../utils/javascript';

const dropPickerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      id="color-picker"
    >
      <path d="M14.586 12L9.293 6.707a1 1 0 1 1 1.414-1.414L12 6.586l3.293-3.293a3.828 3.828 0 0 1 5.414 5.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a1.828 1.828 0 0 0-2.586-2.586L13.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L16 13.414l-7.293 7.293A1 1 0 0 1 8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l5.5-5.5a1 1 0 0 1 1.414 1.414L5 16.414V19h2.586l7-7z"></path>
    </svg>
  );
};

export const EyeDropper = ({ onPick }) => {
  const eyeDropper = useMemo(() => new window.EyeDropper(), []);
  const abortController = useRef();
  const [pickingFromDocument, setPickingFromDocument] = useState(false);

  const close = () => {
    if (typeof abortController.current === 'undefined') return;
    abortController.current.abort();
  };

  const exitPickByEscKey = useCallback(
    event => {
      if (event.code === 'Escape' && pickingFromDocument) {
        setPickingFromDocument(false);
        close();
      }
    },
    [pickingFromDocument],
  );

  useEffect(() => {
    if (pickingFromDocument) {
      document.addEventListener('keydown', exitPickByEscKey);
    }
    return () => {
      document.removeEventListener('keydown', exitPickByEscKey);
    };
  }, [pickingFromDocument, exitPickByEscKey]);

  const onStart = async event => {
    setPickingFromDocument(true);
    try {
      close();
      const controller = new AbortController();
      abortController.current = controller;
      const { sRGBHex } = await eyeDropper.open({
        signal: controller.signal,
      });
      const [r, g, b] = hexToRgbArr(sRGBHex);
      const colors = {
        hex: sRGBHex,
        source: 'hex',
        rgb: { r, g, b, a: 1 }, // sending alpha as 1 by default as chrome eydropper api only returns hex format
      };
      onPick(colors, event);
    } catch (error) {
      console.error({ error });
    }
  };

  return <Icon component={dropPickerIcon} onClick={onStart} />;
};
